export const SHORTCUT_OPTIONS = [
  { name: 'Export summary report', shortcut: '\\E' },
  { name: 'Change accounts', shortcut: '\\C' },
] as const;
